import React, {Component} from 'react';
import axios from 'axios';
import OwlCarousel from 'react-owl-carousel';
import cookie from 'react-cookies';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import Pagination from "react-js-pagination";
import {Redirect} from 'react-router';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class Assets extends Component{
	constructor(props){
		super(props);

		this.state = {
			orgAssetList: [],
			assetList: [],
			dataLanguage: dictionaryList['English'],
			activePage: 1,
			startNumber: 1,
			endNumber: 12,
			assetCountPerPage: 12,
			currentGameId: 0,
			bannerImage: null,
			searchKeyword: '',
			startKeyword: '',
			redirect: null,
			sortAssetOrder: 0,
			toCurrency: null,
			orgCurrencyList: [],
			userAvatarList: {}
		}
		
		this.getTopAssets = this.getTopAssets.bind(this);
		this.setPagination = this.setPagination.bind(this);
		this.showPage = this.showPage.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.makeAssetList = this.makeAssetList.bind(this);
	}
	
	componentWillMount(){
	}

	componentDidMount() {
		if ( localStorage.getItem('Language') ) {
			this.setState({
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			});
		} else {
			this.setState({
				dataLanguage: dictionaryList['English']
			});
		}
		
		this.getCurrencyList();		
	}

	getCurrencyList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCurrencyList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						orgCurrencyList: response.data
					});

					this.getTargetCurrency();
					this.getTopAssets();
				}
			})
	}

	getTargetCurrency() {
		var filteredOptions = [];

		if ( localStorage.getItem('countryId') ) {
			filteredOptions = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.countryId == localStorage.getItem('countryId')
			);

			if (filteredOptions.length == 0) {
				filteredOptions = this.state.orgCurrencyList.filter(
					(currency) =>
					currency.status == 2
				);
			}
		}

		if (filteredOptions.length) {
			this.setState({
				toCurrency: filteredOptions[0]
			})
		} else {
			this.setState({
				toCurrency: null
			})
		}
	}

	getTopAssets() {
		axios.defaults.withCredentials = true;

		var gameId = 0;
		
		if (localStorage.getItem('gameId')) {
			gameId = localStorage.getItem('gameId');
			localStorage.removeItem('gameId');

			this.setState({
				currentGameId: gameId
			})

			axios.get(window.$backend_url + '/getGameImage?gameId=' + gameId)
				.then(response => {
					if ( response.status === 200 ) {
						this.setState({
							bannerImage: '/assets/images/games/' + response.data
						})
					} else {
						this.setState({
							bannerImage: '/assets/images/popular-game-main.jpg'
						})
					}
				})
		} else {
			this.setState({
				currentGameId: 0,
				bannerImage: '/assets/images/popular-game-main.jpg'
			})
		}
		
		axios.get(window.$backend_url + '/getTopAssetList?gameId=' + gameId + '&max_count=0')
			.then(response => {
				if ( response.status === 200 ) {
					if (response.data.length < this.state.endNumber) {
						this.setState({
							endNumber: response.data.length
						})
					}

					response.data.sort((a, b) => (b.recentLikeCount - b.recentDislikeCount) - (a.recentLikeCount - a.recentDislikeCount));

					let tempList0 = [];
					let tempList1 = [];
					let tempList2 = [];
					for (var i=0; i<response.data.length; i++) {
						tempList0.push(i);
						response.data[i].avatarImage = '/assets/images/loading.gif';

						if (response.data[i].mainImageUrl) {
							response.data[i].assetImage = response.data[i].mainImageUrl;
						} else {
							response.data[i].assetImage = '/assets/images/loading.gif';
						}
					}

					this.setState({
						orgAssetList: response.data,
						assetList: tempList0,
						activePage: 1
					}, function(){
						this.setPagination();
					})
				}
			})
	}

	goProfilePage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('userId', e.target.getAttribute('rel'));
			// this.setState({ redirect: "/profile" });
			this.props.history.push('/profile');
		}
	}

	goAssetPage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('gameId', e.target.getAttribute('rel'));
			// this.setState({ redirect: "/assets" });

			this.setState({
				currentGameId: e.target.getAttribute('rel')
			}, function(){
				this.getTopAssets();
			})
		}
	}

	goAssetDescription(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('assetId', this.state.orgAssetList[e.target.getAttribute('rel')].id);
			localStorage.setItem('assetImage', this.state.orgAssetList[e.target.getAttribute('rel')].assetImage);
			localStorage.setItem('assetOwnerId', this.state.orgAssetList[e.target.getAttribute('rel')].userId);
			localStorage.setItem('assetOwnerName', this.state.orgAssetList[e.target.getAttribute('rel')].first_name + ' ' + this.state.orgAssetList[e.target.getAttribute('rel')].last_name);
			localStorage.setItem('assetOwnerAvatar', this.state.orgAssetList[e.target.getAttribute('rel')].avatarImage);
			// this.setState({ redirect: "/assetDescription" });
			this.props.history.push('/assetDescription');
		}
	}

	setPagination() {
		this.showPage();

		if (this.state.assetList.length) {
			var endNumber = this.state.activePage * this.state.assetCountPerPage;
			if (endNumber > this.state.assetList.length) {
				endNumber = this.state.assetList.length
			}
			for (var i=(this.state.activePage - 1) * this.state.assetCountPerPage; i<endNumber; i++) {
				var assetNumber = this.state.assetList[i];

				if (this.state.orgAssetList[assetNumber].assetImage == '/assets/images/loading.gif') {
					const data = {
						userId: this.state.orgAssetList[assetNumber].userId,
						gameId: this.state.orgAssetList[assetNumber].gameId,
						assetId: this.state.orgAssetList[assetNumber].id
					}

					let currentIndex = assetNumber;

					axios.post(window.$backend_url + '/getAssetMainImage', data)
						.then(response => {
							if ( response.status === 200 ) {
								let temp = this.state.orgAssetList;								
								temp[currentIndex].assetImage = response.data;
								this.setState({
									orgAssetList: temp
								})

								this.showPage();
							}
						})
						.catch(error => {
							let temp = this.state.orgAssetList;
							temp[currentIndex].assetImage = 'assets/images/popular-game-main.jpg';
							this.setState({
								orgAssetList: temp
							})

							this.showPage();
						})
				}

				if (!this.state.userAvatarList[this.state.orgAssetList[assetNumber].userId]) {
					var temp = this.state.userAvatarList;
					temp[this.state.orgAssetList[assetNumber].userId] = '/assets/images/loading.gif';
					this.setState({
						userAvatarList: temp
					})

					let currentIndex2 = assetNumber;

					const data2 = {
						userid: this.state.orgAssetList[assetNumber].userId
					}					

					axios.post(window.$backend_url + '/getUserAvatar', data2)
						.then(response => {
							if ( response.status === 200 ) {
								var temp = this.state.userAvatarList;
								temp[this.state.orgAssetList[currentIndex2].userId] = response.data;
								this.setState({
									userAvatarList: temp
								})

								this.showPage();
							}
						})
						.catch(error => {
							var temp = this.state.userAvatarList;
							temp[this.state.orgAssetList[currentIndex2].userId] = 'assets/images/profile-img.png';
							this.setState({
								userAvatarList: temp
							})

							this.showPage();
						})
				}
			}
		}
	}

	showPage() {
		let slider = this.state.assetList.map((assetNumber, index) => {
			if (index >= (this.state.activePage - 1) * this.state.assetCountPerPage && index < this.state.activePage * this.state.assetCountPerPage) {
				let assetBackStyle = {
					 backgroundImage: "url('" + this.state.orgAssetList[assetNumber].assetImage + "')"
				};

				let userBackStyle = {
					 backgroundImage: "url('" + '/assets/images/loading.gif' + "')"
				};

				if (this.state.userAvatarList[this.state.orgAssetList[assetNumber].userId]) {
					userBackStyle = {
						 backgroundImage: "url('" + this.state.userAvatarList[this.state.orgAssetList[assetNumber].userId] + "')"
					};
				}

				var filteredOptions = this.state.orgCurrencyList.filter(
					(currency) =>
					currency.id == this.state.orgAssetList[assetNumber].currencyId
				);

				var symbol = '$';
				var price = this.state.orgAssetList[assetNumber].price;

				if (this.state.toCurrency) {
					symbol = this.state.toCurrency.symbol;
					price = parseFloat((parseFloat(price) * parseFloat(this.state.toCurrency.rate)).toFixed(2));
				}

				return(
					<div key={index} className="col-md-4 col-ms-6 col-12">
						<div className="item">
							<div className="assetImage" style={assetBackStyle}></div>
							<div className="details">
								<div className="profile-img">
									<div className="userAvatar" style={userBackStyle} onClick={this.goProfilePage.bind(this)} rel={this.state.orgAssetList[assetNumber].userId}></div>
								</div>
								<div className="profile-details">
									<p className="userName" onClick={this.goProfilePage.bind(this)} rel={this.state.orgAssetList[assetNumber].userId}>{this.state.orgAssetList[assetNumber].first_name} {this.state.orgAssetList[assetNumber].last_name}</p>
									<p><span>{this.state.dataLanguage['item_name']}:</span> {this.state.orgAssetList[assetNumber].name}</p>
									<p><span>{this.state.dataLanguage['game']}:</span> <span className="gameName" onClick={this.goAssetPage.bind(this)} rel={this.state.orgAssetList[assetNumber].gameId}>{this.state.orgAssetList[assetNumber].gameName}</span></p>
								</div>
								<div className="profile-likes">
									<p><img onClick={this.goAssetDescription.bind(this)} rel={assetNumber} alt="" src="/assets/images/icons/like-icon.png" />{this.state.orgAssetList[assetNumber].likeCount}</p>
									<p><img onClick={this.goAssetDescription.bind(this)} rel={assetNumber} alt="" src="/assets/images/icons/dislike-icon.png" />{this.state.orgAssetList[assetNumber].dislikeCount}</p>
								</div>
								<div className="profile-view">
									<p>{symbol} {price}</p>
									<p><a className="view-item" href="" onClick={this.goAssetDescription.bind(this)} rel={assetNumber} >{this.state.dataLanguage['view_item']}</a></p>
								</div>
							</div>
						</div>
					</div>
				)
			} else {
				return (null);
			}
		});

		this.setState({
			allAssetList: slider
		});
	}

	makeAssetList() {
		let newList = [];

		for (var i=0; i<this.state.orgAssetList.length; i++) {
			if (this.state.sortAssetOrder < 4 && this.state.orgAssetList[i] == 0) {
				continue;
			}
			if (this.state.startKeyword) {
				if (this.state.orgAssetList[i].name.toUpperCase().charAt(0) === this.state.startKeyword) {
					newList.push(i);
				}
			} else if (this.state.orgAssetList[i].name.toLowerCase().includes(this.state.searchKeyword.toLowerCase())) {
				newList.push(i);
			}
		}

		this.setState({
				assetList: newList
			},
			function(){
				if (newList.length < this.state.assetCountPerPage) {
					this.setState({
						endNumber: newList.length
					})
				} else {
					this.setState({
						endNumber: this.state.assetCountPerPage
					})
				}

				this.setPagination();
		});
	}

	searchGame(e) {
		this.setState({
			searchKeyword: '',
			startKeyword: e.target.value,
			startNumber: 1,
			activePage: 1
		}, function(){
			this.makeAssetList();
		})
	}

	initSearchKeyword = (e) => {
		this.setState({
			startKeyword: ''
		}, function () {
			this.makeAssetList();
		});
	}

	searchKeywordChangeHandler = (e) => {
		this.setState({
			searchKeyword: e.target.value,
			startKeyword: '',
			startNumber: 1,
			activePage: 1
		}, function () {
			this.makeAssetList();
		});
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		}, function(){
			this.getTopAssets();
		})

	}

	handlePageChange(pageNumber) {
		this.setState({
			activePage: pageNumber,
			startNumber: (pageNumber - 1) * this.state.assetCountPerPage + 1,
			endNumber: pageNumber * this.state.assetCountPerPage,
		});

		if (pageNumber * this.state.assetCountPerPage > this.state.assetList.length) {
			this.setState({
				endNumber: this.state.assetList.length
			})
		}

		this.setPagination();
		window.scrollTo(0, this.refs.asset_list.offsetTop - 30);
	}

	checkLogin() {
		if (cookie.load('cookieId')) {
			this.setState({
				isLogin: true
			})
		} else {
			this.setState({
				isLogin: false
			})
		}

		this.getTargetCurrency();
		this.setPagination();
	}

	sortAsset = (e) => {
		if (this.state.orgAssetList) {
			switch (e.target.getAttribute('rel')) {
				case "1":
					this.state.orgAssetList.sort((a, b) => b.commentCount - a.commentCount);
					break;
				case "2":
					this.state.orgAssetList.sort((a, b) => (new Date(b.createDate)) - (new Date(a.createDate)));
					break;
				case "3":
					this.state.orgAssetList.sort((a, b) => (b.likeCount - b.dislikeCount) - (a.likeCount - a.dislikeCount));
					break;
				default:
					this.state.orgAssetList.sort((a, b) => (b.recentLikeCount - b.recentDislikeCount) - (a.recentLikeCount - a.recentDislikeCount));
			}
		}

		this.setState({
			sortAssetOrder: e.target.getAttribute('rel')
		}, function(){
			this.makeAssetList();
		})
	}

	render(){
		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		return(
			<div className="digit asset">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="3" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />
							
							{ this.state.bannerImage ?
								<div className="banner-slider">
									<div className="owl-slider">
										<OwlCarousel items={1} className="owl-theme" margin={1} responsiveClass={true} >
											<div><img alt="" className="img" src= {this.state.bannerImage}/></div>
										</OwlCarousel>
									</div>
								</div>
							: null }
							<div className="search-container-out">
								<div className="search-container game-search">
									<div className="form">
										<input name="search" placeholder={this.state.dataLanguage['search_assets']} type="text" value={this.state.searchKeyword} onChange={this.searchKeywordChangeHandler} />
										<button onClick={this.initSearchKeyword}><img alt="" src="/assets/images/search-icon.png" /></button>
									</div>
								</div>
								<div className="alpahbet-buttons text-center">
									<button onClick={this.searchGame.bind(this)} value="">{this.state.dataLanguage['all']}</button>
									<button onClick={this.searchGame.bind(this)} value="A">A</button>
									<button onClick={this.searchGame.bind(this)} value="B">B</button>
									<button onClick={this.searchGame.bind(this)} value="C">C</button>
									<button onClick={this.searchGame.bind(this)} value="D">D</button>
									<button onClick={this.searchGame.bind(this)} value="E">E</button>
									<button onClick={this.searchGame.bind(this)} value="F">F</button>
									<button onClick={this.searchGame.bind(this)} value="G">G</button>
									<button onClick={this.searchGame.bind(this)} value="H">H</button>
									<button onClick={this.searchGame.bind(this)} value="I">I</button>
									<button onClick={this.searchGame.bind(this)} value="J">J</button>
									<button onClick={this.searchGame.bind(this)} value="K">K</button>
									<button onClick={this.searchGame.bind(this)} value="L">L</button>
									<button onClick={this.searchGame.bind(this)} value="M">M</button>
									<button onClick={this.searchGame.bind(this)} value="N">N</button>
									<button onClick={this.searchGame.bind(this)} value="O">O</button>
									<button onClick={this.searchGame.bind(this)} value="P">P</button>
									<button onClick={this.searchGame.bind(this)} value="Q">Q</button>
									<button onClick={this.searchGame.bind(this)} value="R">R</button>
									<button onClick={this.searchGame.bind(this)} value="S">S</button>
									<button onClick={this.searchGame.bind(this)} value="T">T</button>
									<button onClick={this.searchGame.bind(this)} value="U">U</button>
									<button onClick={this.searchGame.bind(this)} value="V">V</button>
									<button onClick={this.searchGame.bind(this)} value="W">W</button>
									<button onClick={this.searchGame.bind(this)} value="X">X</button>
									<button onClick={this.searchGame.bind(this)} value="Y">Y</button>
									<button onClick={this.searchGame.bind(this)} value="Z">Z</button>
								</div>
							</div>
						</div>
					</section>					
					
					<div className="main-area">
						<div className="container">
							<div className="tab">
								<ul>
									<li className={this.state.sortAssetOrder == 0 || !this.state.sortAssetOrder ? "clicked" : ''} onClick={this.sortAsset} rel="0">{this.state.dataLanguage['trending']}</li>
									<li className={this.state.sortAssetOrder == 1 ? "clicked" : ''} onClick={this.sortAsset} rel="1">{this.state.dataLanguage['most_commented']}</li>
									<li className={this.state.sortAssetOrder == 2 ? "clicked" : ''} onClick={this.sortAsset} rel="2">{this.state.dataLanguage['most_recent']}</li>
									<li className={this.state.sortAssetOrder == 3 ? "clicked" : ''} onClick={this.sortAsset} rel="3">{this.state.dataLanguage['nearing_addition']}</li>
								</ul>
							</div>
							<div ref="asset_list" className="asset-list game-slider">
								{ this.state.allAssetList ?
									<div className="row">
										{this.state.allAssetList}
									</div>
								: null }
							</div>
							<div className="paginationContainer">
								<div className="row">
									<div className="col-md-6">
										{ this.state.assetList.length ?
											<p className="paginationText">{this.state.dataLanguage['showing']} {this.state.startNumber}-{this.state.endNumber} {this.state.dataLanguage['of']} {this.state.assetList.length} {this.state.dataLanguage['results']}</p>
										: 
											<p className="paginationText">0 {this.state.dataLanguage['result']}</p>
										}
									</div>
									<div className="col-md-6 text-right">
										{ this.state.assetList.length ?
											<Pagination
											  activePage={this.state.activePage}
											  itemsCountPerPage={this.state.assetCountPerPage}
											  totalItemsCount={this.state.assetList.length}
											  pageRangeDisplayed={5}
											  itemClass="btnPagination"
											  itemClassFirst="btnControl"
											  itemClassLast="btnControl"
											  itemClassNext="btnControl"
											  itemClassPrev="btnControl"
											  prevPageText="<"
											  nextPageText=">"
											  onChange={this.handlePageChange}
											/>
										: null }
									</div>
								</div>
							</div>
						</div>
					</div>					
				</div>
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
			</div>
		)
	}
}

export default Assets;


// WEBPACK FOOTER //
// ./src/components/Assets.js